import { createLoyaltyPromotion } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/create-loyalty-promotion";
import { deleteLoyaltyPromotion } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/delete-loyalty-promotion";
import { getLoyaltyConfiguration } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/get-loyalty-configuration";
import { getLoyaltyMembers } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/get-loyalty-members";
import { getLoyaltyMetrics } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/get-loyalty-metrics";
import { getLoyaltyPopupSettings } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/get-loyalty-popup-settings";
import { getLoyaltyPromotions } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/get-loyalty-promotions";
import { getLoyaltyRefundEventForReturn } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/get-loyalty-refund-event-for-return";
import { getLoyaltyPointsEarnedFromOrder } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/get-points-earned-from-order";
import { updateLoyaltyPageSettings } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/update-loyalty-page";
import { updateLoyaltyPopupSettings } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/update-loyalty-popup-settings";
import { updateLoyaltyPromotion } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/update-loyalty-promotion";
import { upsertLoyaltyConfiguration } from "@redotech/redo-merchant-marketing-rpc/schema/loyalty/upsert-loyalty-configuration";
import type { InferRpcDefinition } from "@redotech/rpc/definition";

export const rpcDefinition = {
  createLoyaltyPromotion,
  deleteLoyaltyPromotion,
  getLoyaltyConfiguration,
  getLoyaltyMembers,
  getLoyaltyMetrics,
  getLoyaltyPointsEarnedFromOrder,
  getLoyaltyPopupSettings,
  getLoyaltyPromotions,
  getLoyaltyRefundEventForReturn,
  updateLoyaltyPageSettings,
  updateLoyaltyPopupSettings,
  updateLoyaltyPromotion,
  upsertLoyaltyConfiguration,
};

export type RedoMerchantLoyaltyRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
